import { render, staticRenderFns } from "./datashareForm.vue?vue&type=template&id=e355850e"
import script from "./datashareForm.vue?vue&type=script&lang=js"
export * from "./datashareForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports